import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Modal } from 'react-bootstrap'
import ModalButton from '../ButtonWithTooltip'
import { modalsPropTypes, getActiveModal, getStateProps } from './modals'

class AppModalComponent extends React.Component {
  constructor (props) { // eslint-disable-line
    super(props)
    this.activeModal = false
  }

  renderNoActiveModal () {
    if (!this.activeModal) {
      return null
    }
    this.activeModal = false
    return <Modal show={false} animation={false} />
  }

  renderActiveModal (modalData) {
    this.activeModal = true

    const {
      className = '',
      backdropAppClassName = '',
      backdropClassName = '',
      iconClass = '',
      title = 'title',
      body = null,
      note = null,
      buttons = null,
    } = modalData

    const debug = false // make this true to move the modal top/left

    return (
      <Modal
        animation={false}
        show={true}
        className={`app-modal ${className} ${debug ? 'modal-debug' : ''}`}
        backdropClassName={`app-modal ${backdropAppClassName} ${backdropClassName} ${debug ? 'modal-debug' : ''}`}
        onHide={() => {}}
      >
        <Modal.Body>
          {iconClass && <div className={`modal-icon ${iconClass}`} />}
          <h4 className={'modal-title'} dangerouslySetInnerHTML={{ __html: this.context.t(title) }} ></h4>
          {body && (typeof body === 'string')
            ? <div className={'modal-text'} dangerouslySetInnerHTML={{ __html: this.context.t(body) }} ></div>
            : <div className={'modal-text'}>{body}</div>
          }
          {note && (typeof note === 'string')
            ? <div className={'modal-note'} dangerouslySetInnerHTML={{ __html: this.context.t(note) }} ></div>
            : (note && <div className={'modal-note'}>{note}</div>)
          }
        </Modal.Body>
        {buttons &&
          <Modal.Footer>
            {buttons.map((button, index) =>
              (<ModalButton
                tooltip={
                  button.tooltip
                    ? (typeof button.tooltip === 'string'
                      ? this.context.t(button.tooltip)
                      : button.tooltip)
                    : null
                }
                key={`btn-${index}`}
                disabled={Boolean(button.disabled)}
                onClick={button.onClick}
                className={`modal-button ${button.className || ''}`}
              >
                {this.context.t(button.text)}
              </ModalButton>))
            }
          </Modal.Footer>
        }
      </Modal>
    )
  }

  render () {
    const modalData = getActiveModal({
      state: this.props.stateObj.state,
      dispatch: this.props.dispatch,
      translate: this.context.t,
    })

    if (modalData) {
      Object.assign(modalData, { backdropAppClassName: this.props.backdropAppClassName || '' })
    }

    return modalData
      ? this.renderActiveModal(modalData)
      : this.renderNoActiveModal()
  }
}


AppModalComponent.contextTypes = {
  t: PropTypes.func.isRequired
}

AppModalComponent.propTypes = {
  ...modalsPropTypes,
  stateObj: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  backdropAppClassName: PropTypes.string,
}

// static object to send the state to modal.getModalData
// we keep it unmutable to not trigger AppModal.render at each
// state change
const stateObj = {}

export function mapStateToProps (state) {
  // get props declared by all modals values
  // the AppModal render will be called whenever
  // any of this props change
  const props = getStateProps(state)

  stateObj.state = state
  props.stateObj = stateObj

  return props
}

const mapDispatchToProps = (dispatch) => ({
  dispatch,
})

export const AppModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppModalComponent)
